import {
    apiClient
} from '@/services/config.js';



export default {
    fetchMyNextShifts(id) {
        return apiClient.get(
            "/api/shift-registrations/?member=" +
            id +
            "&state=open");
    },
    fetchMyShifts(id, date) {
        return apiClient.get(
            "/api/shift-registrations/?member=" +
            id +
            "&dateBegin>" +
            date);
    },
    fetchOpenShifts() {
        return apiClient.get(
            "/api/shift-tickets/?name=Volant");
    },
    subscribeOpenShifts(ShiftId,ServiceId,DateBegin,userId) {
        return apiClient.post("/api/shift-registrations", {
            shift: ShiftId,
            shiftTicket: ServiceId,
            state: "open",
            dateBegin: DateBegin,
            member: userId
        });
    },
};
